import { useField } from "formik";

export const useUniqueField = () => {
  const [{ value: uniqueField }, , { setValue }] = useField<string | null>(
    "unique_field"
  );

  return [uniqueField ?? "", setValue] as const;
};
